<template>
  <LangRouterLink v-if="route" class="button" :to="route">
    <span>{{ label }}</span>
    <Icon id="arrow" />
  </LangRouterLink>
  <a v-else class="button" :href="link" target="_blank">
    <span>{{ label }}</span>
    <Icon id="arrow" />
  </a>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'Button',
  components: {
    Icon,
    LangRouterLink,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    route: {
      type: Object,
      required: false,
    },
  },
}
</script>
